import React from "react";
import AppRoutes from "./routes/AppRoutes";
import "./Style/responsive.css";


const App = () => {

  return (

    <div className="App">
      <AppRoutes />
    </div>
    
  );
};

export default App;